module.exports = "<!-- <app-master></app-master> -->\r\n<div [@routerAnimation]=\"getRouteAnimation(route)\">\r\n  <router-outlet #route=\"outlet\"></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Venkat Projects/sagiam-tool-angular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main